<template>
  <f7-page>
    <navbar :text="$t('PrescriptionManager_navbar_title')" />
    <DxPrescriptionManager />
  </f7-page>
</template>

<script>

import navbar from '../../components/NavBar.vue';
import DxPrescriptionManager from '../../components/prescriptions/DxPrescriptionManager.vue';

export default {
  name: 'PrescriptionManager',
  components: {
    navbar,
    DxPrescriptionManager,
  },
};
</script>

<style>

</style>
